import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import DashboardTab from "./Tabs/DashboardTab";
import MaterialsTab from "./Tabs/MaterialsTab";
import "./DashboardContainer.scss";

const DashboardContainer = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="dashboard-container">
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        className="dashboard-tabview"
      >
        <TabPanel header="Dashboard">
          <DashboardTab />
        </TabPanel>
        <TabPanel header="Materials">
          <MaterialsTab />
        </TabPanel>
      </TabView>
    </div>
  );
};

export { DashboardContainer };
